export default {
  title: 'Streams',
  description: 'Gestion des diffusions en direct',
  create: 'Créer un stream',
  goLive: 'Démarrer le direct',
  endStream: 'Terminer le stream',
  stream: {
    title: 'Titre du stream',
    description: 'Description du stream',
    status: 'Statut',
    live: 'En direct',
    offline: 'Hors ligne',
    scheduled: 'Programmé',
    ended: 'Terminé',
    viewers: 'Spectateurs',
    duration: 'Durée',
    startTime: 'Heure de début',
    endTime: 'Heure de fin',
    streamKey: 'Clé de stream',
    streamUrl: 'URL du stream'
  },
  settings: {
    title: 'Paramètres du stream',
    quality: 'Qualité',
    resolution: 'Résolution',
    bitrate: 'Débit',
    frameRate: 'Images par seconde',
    audio: 'Paramètres audio',
    video: 'Paramètres vidéo',
    privacy: 'Confidentialité',
    public: 'Public',
    private: 'Privé',
    unlisted: 'Non répertorié'
  },
  chat: {
    title: 'Chat en direct',
    send: 'Envoyer',
    moderator: 'Modérateur',
    viewer: 'Spectateur',
    disabled: 'Chat désactivé'
  }
}